import { gql } from '@apollo/client';

// GraphQL queries and mutations for audiences
export const GET_AUDIENCES_BY_AGENT = gql`
  query GetAudiencesByAgent($data: GetAudiencesByAgentInputType!) {
    getAudiencesByAgent(data: $data) {
      data
      hasError
      message
    }
  }
`;

export const CREATE_AUDIENCE_WITH_CONTACTS = gql`
  mutation CreateAudienceWithContacts(
    $data: CreateAudienceWithContactsInputType!
  ) {
    createAudienceWithContacts(data: $data) {
      data
      hasError
      message
    }
  }
`;

export const DELETE_AUDIENCE = gql`
  mutation DeleteAudience($audience_id: String!) {
    deleteAudience(audience_id: $audience_id) {
      data
      hasError
      message
    }
  }
`;

export const ADD_CONTACTS_TO_AUDIENCE = gql`
  mutation AddContactsToAudience($data: AddContactsToAudienceInputType!) {
    addContactsToAudience(data: $data) {
      data
      hasError
      message
    }
  }
`;
